import React from 'react'

import { input as Input } from '../styles'

function input(props) {
  return (
    <Input>
      {props.type === 'checkbox' ? (
        <Checkbox {...props} />
      ) : (
        <input {...props} />
      )}
    </Input>
  )
}

const Checkbox = props => <input id="c1" type="checkbox" {...props} />

export default input
